module.exports = __webpack_public_path__ + "static/media/logo.4f62d0b4.svg";